import React, { Component } from "react";
import PropTypes from "prop-types";

class Icon extends Component {
  _mergeStyles(...args) {
    // This is the m function from "CSS in JS" and can be extracted to a mixin
    return Object.assign({}, ...args);
  }

  renderGraphic() {
    switch (this.props.icon) {
      case "risk":
        return (
          <g>
            <g>
              <path
                d="M19.9,18.9c0.1,0.2,0.1,0.5,0,0.7c-0.1,0.2-0.3,0.4-0.6,0.4h-7.1c-0.3,0-0.5-0.1-0.6-0.4c-0.1-0.2-0.1-0.5,0-0.7l3.5-6.1
        c0.1-0.2,0.3-0.4,0.6-0.4s0.5,0.1,0.6,0.4L19.9,18.9z M16.2,17.9c-0.1-0.1-0.3-0.2-0.5-0.2s-0.3,0.1-0.5,0.2
        c-0.1,0.1-0.2,0.3-0.2,0.5c0,0.2,0.1,0.3,0.2,0.5c0.1,0.1,0.3,0.2,0.5,0.2s0.3-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5
        C16.4,18.2,16.4,18,16.2,17.9z M15.1,15.2l0.1,2c0,0.1,0.1,0.2,0.2,0.2h0.7c0.1,0,0.2-0.1,0.2-0.2l0.1-2c0-0.1,0-0.1-0.1-0.1
        c0,0-0.1-0.1-0.1-0.1h-0.9c0,0-0.1,0-0.1,0.1C15.1,15.1,15.1,15.2,15.1,15.2z"
              />
            </g>
            <g>
              <path
                d="M10.8,2.1c0.4,0,0.8,0.2,1.1,0.5c0.3,0.3,0.5,0.7,0.5,1.1V15c0,0.4-0.2,0.8-0.5,1.1c-0.3,0.3-0.7,0.5-1.1,0.5H1.5
        c-0.4,0-0.8-0.2-1.1-0.5C0.2,15.8,0,15.4,0,15V3.6c0-0.4,0.2-0.8,0.5-1.1s0.7-0.5,1.1-0.5h2.6c0-0.6,0.2-1,0.6-1.5S5.6,0,6.2,0
        s1,0.2,1.5,0.6s0.6,0.9,0.6,1.5H10.8z M2.6,7.3c0.2,0.2,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.5-0.2c0.2-0.2,0.2-0.3,0.2-0.5
        S3.8,6.3,3.6,6.2C3.5,6,3.3,5.9,3.1,5.9C2.9,5.9,2.7,6,2.6,6.2C2.4,6.3,2.3,6.5,2.3,6.7S2.4,7.1,2.6,7.3z M2.6,10.4
        c0.2,0.2,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.5-0.2c0.2-0.2,0.2-0.3,0.2-0.5S3.8,9.4,3.6,9.3C3.5,9.1,3.3,9,3.1,9
        C2.9,9,2.7,9.1,2.6,9.3C2.4,9.4,2.3,9.6,2.3,9.8S2.4,10.2,2.6,10.4z M2.6,13.5c0.2,0.2,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.5-0.2
        c0.2-0.2,0.2-0.3,0.2-0.5c0-0.2-0.1-0.4-0.2-0.5c-0.2-0.2-0.3-0.2-0.5-0.2c-0.2,0-0.4,0.1-0.5,0.2c-0.2,0.2-0.2,0.3-0.2,0.5
        C2.3,13.1,2.4,13.3,2.6,13.5z M10.3,7V6.5c0-0.2-0.1-0.3-0.3-0.3H5.4c-0.2,0-0.3,0.1-0.3,0.3V7c0,0.2,0.1,0.3,0.3,0.3h4.6
        C10.2,7.2,10.3,7.1,10.3,7z M10.3,10.1V9.6c0-0.2-0.1-0.3-0.3-0.3H5.4c-0.2,0-0.3,0.1-0.3,0.3v0.5c0,0.2,0.1,0.3,0.3,0.3h4.6
        C10.2,10.3,10.3,10.2,10.3,10.1z M10.3,13.2v-0.5c0-0.2-0.1-0.3-0.3-0.3H5.4c-0.2,0-0.3,0.1-0.3,0.3v0.5c0,0.2,0.1,0.3,0.3,0.3h4.6
        C10.2,13.4,10.3,13.3,10.3,13.2z M6.7,1.5C6.6,1.4,6.4,1.3,6.2,1.3C6,1.3,5.8,1.4,5.6,1.5C5.5,1.7,5.4,1.9,5.4,2.1
        c0,0.2,0.1,0.4,0.2,0.5C5.8,2.8,6,2.8,6.2,2.8c0.2,0,0.4-0.1,0.5-0.2C6.9,2.5,7,2.3,7,2.1C7,1.9,6.9,1.7,6.7,1.5z"
              />
            </g>
          </g>
        );
      case "payment":
        return (
          <path
            d="M19.6,12.6c0.2,0.2,0.4,0.6,0.3,0.9c0,0.4-0.1,0.7-0.4,0.9l-5.3,4.5c-0.4,0.3-0.9,0.5-1.4,0.5H0.6c-0.1,0-0.3-0.1-0.4-0.2
        C0.1,19.1,0,19,0,18.8v-3.5c0-0.2,0.1-0.3,0.2-0.4c0.1-0.1,0.2-0.2,0.4-0.2h2l1.6-1.4c0.8-0.6,1.6-1,2.6-1h5.6
        c0.3,0,0.6,0.1,0.9,0.4c0.2,0.3,0.3,0.6,0.2,0.9c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.3-0.4,0.3c-0.2,0.1-0.3,0.1-0.5,0.1H9.5
        c-0.1,0-0.3,0.1-0.4,0.2C9,15,8.9,15.1,8.9,15.3c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.2,0.2,0.4,0.2h4.1c0.5,0,1-0.2,1.4-0.5l3.2-2.7
        c0.2-0.2,0.5-0.3,0.7-0.3C19.2,12.4,19.4,12.5,19.6,12.6z M9.5,5.9C9.1,5.8,8.7,5.5,8.4,5.2C8.1,4.9,8,4.6,7.9,4.1
        C7.8,3.6,8,3,8.3,2.6c0.4-0.5,0.8-0.7,1.4-0.8V1.2c0-0.2,0.1-0.3,0.2-0.4c0.1-0.1,0.3-0.2,0.4-0.2h0.6c0.2,0,0.3,0.1,0.4,0.2
        s0.2,0.3,0.2,0.4v0.7c0.4,0,0.8,0.2,1.2,0.4c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1,0,0.3-0.1,0.4l-0.6,0.6c-0.1,0.1-0.3,0.2-0.5,0.1
        c-0.1,0-0.3-0.1-0.4-0.1H10c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.2,0.3l1.8,0.6c0.3,0.1,0.5,0.2,0.8,0.4
        c0.2,0.2,0.4,0.4,0.6,0.6c0.1,0.2,0.2,0.5,0.3,0.8C13.4,7,13.2,7.5,12.9,8c-0.4,0.5-0.8,0.7-1.4,0.8v0.7c0,0.2-0.1,0.3-0.2,0.4
        S11.1,10,10.9,10h-0.6c-0.2,0-0.3-0.1-0.4-0.2C9.8,9.7,9.7,9.6,9.7,9.4V8.7c-0.4,0-0.8-0.2-1.2-0.4C8.4,8.3,8.4,8.2,8.4,8
        c0-0.1,0-0.3,0.1-0.4L9.1,7c0.1-0.1,0.3-0.2,0.5-0.1C9.8,7,9.9,7,10,7h1.2c0.2,0,0.3-0.1,0.3-0.3c0-0.2-0.1-0.3-0.2-0.3L9.5,5.9z"
          />
        );
      case "copy":
        return (
          <path d="M0,8.00585866 C0,6.89805351 0.897060126,6 2.00585866,6 L11.9941413,6 C13.1019465,6 14,6.89706013 14,8.00585866 L14,17.9941413 C14,19.1019465 13.1029399,20 11.9941413,20 L2.00585866,20 C0.898053512,20 0,19.1029399 0,17.9941413 L0,8.00585866 L0,8.00585866 Z M6,8 L2,8 L2,18 L12,18 L12,14 L15,14 L15,12 L18,12 L18,2 L8,2 L8,5 L6,5 L6,8 L12,8 L12,14 L17.9941413,14 C19.1029399,14 20,13.1019465 20,11.9941413 L20,2.00585866 C20,0.897060126 19.1019465,0 17.9941413,0 L8.00585866,0 C6.89706013,0 6,0.898053512 6,2.00585866 L6,8 Z"/>
        );
      case "location":
        return (
          <path
            d="M0.7,8.6l4.1-1.7C5,7.4,5.2,8,5.6,8.6v8.1l-4.8,2.2c-0.1,0-0.2,0.1-0.3,0c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0-0.1-0.1-0.2-0.2
        C0,18.5,0,18.4,0,18.3V9.6C0,9.4,0.1,9.2,0.2,9C0.3,8.8,0.5,8.7,0.7,8.6z M6.9,2.4C7.8,1.5,8.8,1.1,10,1.1c1.2,0,2.2,0.4,3.1,1.3
        c0.9,0.9,1.3,1.9,1.3,3.1c0,1.4-1.3,3.7-4,6.8c-0.1,0.1-0.3,0.2-0.4,0.2c-0.2,0-0.3-0.1-0.4-0.2c-2.6-3.1-4-5.4-4-6.8
        C5.6,4.3,6.1,3.2,6.9,2.4z M10,13.6c0.5,0,0.9-0.2,1.3-0.6c0.8-0.9,1.4-1.8,2-2.7v8.5l-6.7-2.2v-6.3c0.6,0.9,1.3,1.7,2,2.7
        C9.1,13.4,9.5,13.6,10,13.6z M9,6.5c0.3,0.3,0.6,0.4,1,0.4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1c0-0.4-0.1-0.7-0.4-1
        C10.7,4.2,10.4,4,10,4C9.6,4,9.3,4.2,9,4.5c-0.3,0.3-0.4,0.6-0.4,1C8.5,5.9,8.7,6.2,9,6.5z M19.2,6.7c0.1,0,0.3-0.1,0.4,0
        c0.1,0,0.2,0.1,0.3,0.2C20,7,20,7.1,20,7.2v8.7c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.1,0.3-0.3,0.4c-0.1,0.1-0.2,0.2-0.3,0.2l-4.9,1.9
        v-10L19.2,6.7z"
          />
        );
      case "medical":
        return (
          <path
            d="M18.8,19.2V20H1.2v-0.8c0-0.3,0.2-0.5,0.5-0.5h0.8V4.7c0-0.3,0.1-0.5,0.3-0.7C3,3.8,3.2,3.8,3.4,3.8h3.4V0.9
        c0-0.3,0.1-0.5,0.3-0.7C7.3,0.1,7.6,0,7.8,0h4.4c0.3,0,0.5,0.1,0.7,0.3c0.2,0.2,0.3,0.4,0.3,0.7v2.8h3.4c0.3,0,0.5,0.1,0.7,0.3
        c0.2,0.2,0.3,0.4,0.3,0.7v14.1h0.8C18.6,18.8,18.8,18.9,18.8,19.2z M6.7,10h1.6c0.3,0,0.5-0.2,0.5-0.5V8c0-0.3-0.2-0.5-0.5-0.5H6.7
        C6.4,7.5,6.2,7.7,6.2,8v1.6C6.2,9.8,6.4,10,6.7,10z M8.8,11.7c0-0.3-0.2-0.5-0.5-0.5H6.7c-0.3,0-0.5,0.2-0.5,0.5v1.6
        c0,0.3,0.2,0.5,0.5,0.5h1.6c0.3,0,0.5-0.2,0.5-0.5V11.7z M8.4,3.8h1v1C9.4,4.9,9.5,5,9.6,5h0.8c0.2,0,0.2-0.1,0.2-0.2v-1h1
        c0.2,0,0.2-0.1,0.2-0.2V2.7c0-0.2-0.1-0.2-0.2-0.2h-1v-1c0-0.2-0.1-0.2-0.2-0.2H9.6c-0.2,0-0.2,0.1-0.2,0.2v1h-1
        c-0.2,0-0.2,0.1-0.2,0.2v0.8C8.1,3.7,8.2,3.8,8.4,3.8z M10.8,15H9.2c-0.3,0-0.5,0.2-0.5,0.5v3.3h2.5v-3.3
        C11.2,15.2,11.1,15,10.8,15z M13.3,7.5h-1.6c-0.3,0-0.5,0.2-0.5,0.5v1.6c0,0.3,0.2,0.5,0.5,0.5h1.6c0.3,0,0.5-0.2,0.5-0.5V8
        C13.8,7.7,13.6,7.5,13.3,7.5z M13.3,11.2h-1.6c-0.3,0-0.5,0.2-0.5,0.5v1.6c0,0.3,0.2,0.5,0.5,0.5h1.6c0.3,0,0.5-0.2,0.5-0.5v-1.6
        C13.8,11.4,13.6,11.2,13.3,11.2z"
          />
        );
      case "male":
        return (
          <path
            d="M19.4,0C19.8,0,20,0.2,20,0.6v4.1c0,0.3-0.1,0.5-0.4,0.6c-0.3,0.1-0.5,0.1-0.7-0.1l-0.9-0.9l-4.2,4.2
        c0.8,1.2,1.1,2.6,1.1,4c0,2.1-0.7,3.9-2.2,5.3S9.6,20,7.5,20c-2.1,0-3.9-0.7-5.3-2.2S0,14.6,0,12.5c0-2.1,0.7-3.9,2.2-5.3
        S5.4,5,7.5,5c1.5,0,2.8,0.4,4,1.1l4.2-4.2L14.8,1c-0.2-0.2-0.2-0.4-0.1-0.7S15,0,15.3,0H19.4z M4.6,15.4c0.8,0.8,1.8,1.2,2.9,1.2
        s2.1-0.4,2.9-1.2s1.2-1.8,1.2-2.9c0-1.1-0.4-2.1-1.2-2.9S8.6,8.3,7.5,8.3S5.4,8.7,4.6,9.6s-1.2,1.8-1.2,2.9
        C3.3,13.6,3.7,14.6,4.6,15.4z"
          />
        );
      case "female":
        return (
          <path
            d="M16.4,6.4c0,1.5-0.5,2.9-1.4,4c-0.9,1.2-2.1,1.9-3.6,2.2V15H13c0.4,0,0.5,0.2,0.5,0.5v1.8c0,0.4-0.2,0.5-0.5,0.5h-1.6v1.6
        c0,0.4-0.2,0.5-0.5,0.5H9.1c-0.4,0-0.5-0.2-0.5-0.5v-1.6H7c-0.4,0-0.5-0.2-0.5-0.5v-1.8C6.4,15.2,6.6,15,7,15h1.6v-2.3
        c-1.5-0.3-2.7-1.1-3.6-2.2s-1.4-2.5-1.4-4c0-1.8,0.6-3.3,1.9-4.6S8.2,0,10,0c1.8,0,3.3,0.6,4.6,1.9S16.4,4.6,16.4,6.4z M7.5,3.9
        c-0.7,0.7-1,1.5-1,2.5s0.3,1.8,1,2.5S9,10,10,10s1.8-0.3,2.5-1s1-1.5,1-2.5s-0.3-1.8-1-2.5s-1.5-1-2.5-1S8.2,3.2,7.5,3.9z"
          />
        );
      case "school":
        return (
          <path
            d="M19.4,6.8C19.8,6.9,20,7.1,20,7.5c0,0.4-0.2,0.6-0.6,0.7l-8.7,2.7c-0.5,0.2-1,0.2-1.4,0L3.2,9c-0.4,0.3-0.6,0.7-0.7,1.2
        C2.8,10.4,3,10.6,3,11c0,0.3-0.1,0.6-0.4,0.8l0.8,3.6c0,0.1,0,0.3-0.1,0.4S3,16,2.9,16H1.1c-0.2,0-0.3-0.1-0.4-0.2
        s-0.1-0.3-0.1-0.4l0.8-3.6C1.1,11.6,1,11.3,1,11c0-0.4,0.2-0.7,0.5-0.8c0-0.5,0.2-1,0.6-1.5L0.6,8.2C0.2,8.1,0,7.9,0,7.5
        c0-0.4,0.2-0.6,0.6-0.7l8.7-2.7c0.5-0.2,1-0.2,1.4,0L19.4,6.8z M11,11.8l4.5-1.4L16,14c0,0.6-0.6,1-1.8,1.4
        C13.1,15.8,11.7,16,10,16c-1.7,0-3.1-0.2-4.2-0.6C4.6,15,4,14.6,4,14l0.4-3.5L9,11.8C9.7,12.1,10.3,12.1,11,11.8z"
          />
        );
      case "view-feedback":
        return (
          <path
            d="M12.3,3.9c1.4,1.1,2.1,2.4,2.1,3.9s-0.7,2.8-2.1,3.9c-1.4,1.1-3.1,1.6-5.1,1.6c-1.4,0-2.7-0.3-3.9-0.9
        c-1,0.6-2,0.9-3.1,0.9c0,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.1c0-0.1,0-0.2,0-0.3C0.6,12.4,1,11.8,1.3,11C0.4,10,0,9,0,7.8
        c0-1.5,0.7-2.8,2.1-3.9c1.4-1.1,3.1-1.6,5.1-1.6C9.2,2.2,10.9,2.8,12.3,3.9z M18.7,15.4c0.3,0.8,0.8,1.4,1.2,1.9
        c0.1,0.1,0.1,0.2,0,0.3c0,0.1-0.1,0.2-0.2,0.2c-1.1,0-2.1-0.3-3.1-0.9c-1.2,0.6-2.5,0.9-3.9,0.9c-1.5,0-2.8-0.3-4-0.9
        c-1.2-0.6-2.1-1.4-2.6-2.5c0.4,0,0.8,0.1,1.1,0.1c2.3,0,4.3-0.7,5.9-2c1.6-1.3,2.4-2.9,2.4-4.7c0-0.3,0-0.5,0-0.7
        c1.3,0.4,2.4,1.1,3.2,2s1.2,2,1.2,3.1C20,13.4,19.6,14.5,18.7,15.4z"
          />
        );
      case "timesheet":
        return (
          <path
            d="M18.8,4.4v13.8c0,0.5-0.2,1-0.5,1.3c-0.4,0.4-0.8,0.5-1.3,0.5H3.1c-0.5,0-1-0.2-1.3-0.5c-0.4-0.4-0.5-0.8-0.5-1.3V4.4
        c0-0.5,0.2-1,0.5-1.3c0.4-0.4,0.8-0.5,1.3-0.5H5v-2C5,0.2,5.2,0,5.5,0H7c0.3,0,0.5,0.2,0.5,0.5v2h5v-2C12.5,0.2,12.7,0,13,0h1.6
        C14.8,0,15,0.2,15,0.5v2h1.9c0.5,0,1,0.2,1.3,0.5C18.6,3.4,18.8,3.9,18.8,4.4z M16.9,17.9V6.2H3.1v11.6c0,0.2,0.1,0.2,0.2,0.2h13.3
        C16.8,18.1,16.9,18,16.9,17.9z M7,11.2H5.5c-0.3,0-0.5-0.2-0.5-0.5V9.2c0-0.3,0.2-0.5,0.5-0.5H7c0.3,0,0.5,0.2,0.5,0.5v1.6
        C7.5,11.1,7.3,11.2,7,11.2z M7.5,14.5C7.5,14.8,7.3,15,7,15H5.5C5.2,15,5,14.8,5,14.5V13c0-0.3,0.2-0.5,0.5-0.5H7
        c0.3,0,0.5,0.2,0.5,0.5V14.5z M11.2,10.8c0,0.3-0.2,0.5-0.5,0.5H9.2c-0.3,0-0.5-0.2-0.5-0.5V9.2c0-0.3,0.2-0.5,0.5-0.5h1.6
        c0.3,0,0.5,0.2,0.5,0.5V10.8z M11.2,14.5c0,0.3-0.2,0.5-0.5,0.5H9.2c-0.3,0-0.5-0.2-0.5-0.5V13c0-0.3,0.2-0.5,0.5-0.5h1.6
        c0.3,0,0.5,0.2,0.5,0.5V14.5z M15,10.8c0,0.3-0.2,0.5-0.5,0.5H13c-0.3,0-0.5-0.2-0.5-0.5V9.2c0-0.3,0.2-0.5,0.5-0.5h1.6
        c0.3,0,0.5,0.2,0.5,0.5V10.8z M15,14.5c0,0.3-0.2,0.5-0.5,0.5H13c-0.3,0-0.5-0.2-0.5-0.5V13c0-0.3,0.2-0.5,0.5-0.5h1.6
        c0.3,0,0.5,0.2,0.5,0.5V14.5z"
          />
        );
      case "login":
        return (
          <path
            d="M19.5,16c0.1,0,0.3,0,0.4,0.1s0.1,0.2,0.1,0.4v1c0,0.1,0,0.3-0.1,0.4S19.6,18,19.5,18h-19c-0.1,0-0.3,0-0.4-0.1
        S0,17.6,0,17.5v-1c0-0.1,0-0.3,0.1-0.4S0.4,16,0.5,16H4V3.6c0-0.4,0.1-0.8,0.4-1.1C4.7,2.2,5.1,2,5.5,2h9c0.4,0,0.8,0.2,1.1,0.5
        C15.9,2.8,16,3.2,16,3.6V16H19.5z M12.3,10.7c0.2,0.2,0.4,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.4,0.3-0.7
        c0-0.3-0.1-0.5-0.3-0.7C13.5,9.1,13.3,9,13,9c-0.3,0-0.5,0.1-0.7,0.3C12.1,9.5,12,9.7,12,10C12,10.3,12.1,10.5,12.3,10.7z"
          />
        );
      case "logout":
        return (
          <path
            d="M9.8,2c0.3-0.1,0.6,0,0.9,0.2C10.9,2.4,11,2.7,11,3v15H0.5c-0.1,0-0.3,0-0.4-0.1S0,17.6,0,17.5v-1c0-0.1,0-0.3,0.1-0.4
        S0.4,16,0.5,16H3V4.6C3,4.4,3.1,4.2,3.2,4c0.1-0.2,0.3-0.3,0.5-0.4L9.8,2z M7.7,10.7C7.9,10.9,8,11,8.2,11c0.2,0,0.4-0.1,0.5-0.3
        C8.9,10.5,9,10.3,9,10c0-0.3-0.1-0.5-0.2-0.7C8.6,9.1,8.5,9,8.2,9C8,9,7.9,9.1,7.7,9.3C7.6,9.5,7.5,9.7,7.5,10
        C7.5,10.3,7.6,10.5,7.7,10.7z M19.5,16c0.1,0,0.3,0,0.4,0.1s0.1,0.2,0.1,0.4v1c0,0.1,0,0.3-0.1,0.4S19.6,18,19.5,18H15V6h-3V4h3.5
        c0.4,0,0.8,0.2,1.1,0.5C16.9,4.8,17,5.1,17,5.5V16H19.5z"
          />
        );
      case "participants":
        return (
          <path
            d="M16.2,2.5c0.3,0,0.6,0.1,0.9,0.4c0.2,0.2,0.4,0.5,0.4,0.9c0,0.3-0.1,0.6-0.4,0.9l-3.7,3.7v10.4c0,0.3-0.1,0.6-0.4,0.9
        c-0.2,0.2-0.5,0.4-0.9,0.4h-0.6c-0.3,0-0.6-0.1-0.9-0.4c-0.2-0.2-0.4-0.5-0.4-0.9v-4.4H9.7v4.4c0,0.3-0.1,0.6-0.4,0.9
        C9.1,19.9,8.8,20,8.4,20H7.8c-0.3,0-0.6-0.1-0.9-0.4c-0.2-0.2-0.4-0.5-0.4-0.9V8.3L2.9,4.6C2.6,4.4,2.5,4.1,2.5,3.8
        c0-0.3,0.1-0.6,0.4-0.9c0.2-0.2,0.5-0.4,0.9-0.4c0.3,0,0.6,0.1,0.9,0.4L8,6.2h4l3.4-3.4C15.6,2.6,15.9,2.5,16.2,2.5z M8,4.8
        c-0.5-0.5-0.8-1.2-0.8-2s0.3-1.4,0.8-2S9.2,0,10,0s1.4,0.3,2,0.8s0.8,1.2,0.8,2s-0.3,1.4-0.8,2s-1.2,0.8-2,0.8S8.6,5.4,8,4.8z"
          />
        );
      case "profile":
        return (
          <path
            d="M9.8,11c1.2,0,2.3,0.5,3.1,1.4l-2.4,2.4l-0.2,0.2l0,0.3L10,17.3c0,0.2,0,0.4,0.1,0.7H1.5c-0.4,0-0.8-0.1-1.1-0.4
        C0.1,17.3,0,16.9,0,16.5v-1.3c0-1.1,0.4-2.1,1.2-3C2.1,11.4,3,11,4.2,11h0.5c0.7,0.3,1.5,0.5,2.3,0.5c0.8,0,1.6-0.2,2.3-0.5H9.8z
         M9.8,8.8C9,9.6,8.1,10,7,10c-1.1,0-2-0.4-2.8-1.2S3,7.1,3,6c0-1.1,0.4-2,1.2-2.8S5.9,2,7,2c1.1,0,2,0.4,2.8,1.2S11,4.9,11,6
        C11,7.1,10.6,8,9.8,8.8z M11.2,15.5l4.3-4.3l2.2,2.2l-4.3,4.3L11.6,18c-0.2,0-0.3,0-0.4-0.1C11,17.7,11,17.6,11,17.4L11.2,15.5z
         M19.8,10.4c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.4-0.2,0.5l-1.3,1.3l-2.2-2.2l0.2-0.1l1.2-1.2C17.7,9.1,17.9,9,18.1,9
        c0.2,0,0.4,0.1,0.5,0.2L19.8,10.4z"
          />
        );
      case "register":
        return (
          <path
            d="M9.8,11c1.1,0,2.1,0.4,3,1.2c0.8,0.8,1.2,1.8,1.2,3v1.3c0,0.4-0.1,0.8-0.4,1.1c-0.3,0.3-0.6,0.4-1.1,0.4h-11
        c-0.4,0-0.8-0.1-1.1-0.4C0.1,17.3,0,16.9,0,16.5v-1.3c0-1.1,0.4-2.1,1.2-3C2.1,11.4,3,11,4.2,11h0.5c0.7,0.3,1.5,0.5,2.3,0.5
        c0.8,0,1.6-0.2,2.3-0.5H9.8z M9.8,8.8C9,9.6,8.1,10,7,10c-1.1,0-2-0.4-2.8-1.2S3,7.1,3,6c0-1.1,0.4-2,1.2-2.8S5.9,2,7,2
        c1.1,0,2,0.4,2.8,1.2S11,4.9,11,6C11,7.1,10.6,8,9.8,8.8z M19.5,8.5c0.1,0,0.3,0,0.4,0.1S20,8.9,20,9v1c0,0.1,0,0.3-0.1,0.4
        s-0.2,0.1-0.4,0.1h-2v2c0,0.1,0,0.3-0.1,0.4S17.1,13,17,13h-1c-0.1,0-0.3,0-0.4-0.1s-0.1-0.2-0.1-0.4v-2h-2c-0.1,0-0.3,0-0.4-0.1
        S13,10.1,13,10V9c0-0.1,0-0.3,0.1-0.4s0.2-0.1,0.4-0.1h2v-2c0-0.1,0-0.3,0.1-0.4S15.9,6,16,6h1c0.1,0,0.3,0,0.4,0.1
        s0.1,0.2,0.1,0.4v2H19.5z"
          />
        );
      case "envelope":
        return (
          <path
            d="M10,12.5c-0.2,0-0.5-0.1-0.8-0.2c-0.3-0.1-0.5-0.3-0.7-0.4c-0.2-0.1-0.4-0.3-0.8-0.6s-0.5-0.4-0.6-0.4
        c-3.2-2.3-5.4-4-6.8-5C0.1,5.7,0,5.4,0,5.1V4.4c0-0.5,0.2-1,0.5-1.3c0.4-0.4,0.8-0.5,1.3-0.5h16.2c0.5,0,1,0.2,1.3,0.5
        C19.8,3.4,20,3.9,20,4.4v0.7c0,0.3-0.1,0.6-0.4,0.7c-1.3,1-3.5,2.7-6.8,5c0,0-0.2,0.1-0.6,0.4s-0.6,0.5-0.8,0.6
        c-0.2,0.1-0.4,0.2-0.7,0.4C10.5,12.4,10.2,12.5,10,12.5z M19.6,7.5c0.1-0.1,0.2-0.1,0.3,0C20,7.5,20,7.6,20,7.7v8
        c0,0.5-0.2,1-0.5,1.3c-0.4,0.4-0.8,0.5-1.3,0.5H1.9c-0.5,0-1-0.2-1.3-0.5C0.2,16.6,0,16.1,0,15.6v-8c0-0.1,0-0.2,0.1-0.2
        c0.1,0,0.2,0,0.3,0c0.9,0.7,2.9,2.1,6,4.4c0.1,0.1,0.2,0.2,0.5,0.4c0.3,0.2,0.5,0.4,0.7,0.5c0.2,0.1,0.4,0.3,0.7,0.4
        c0.3,0.2,0.6,0.3,0.8,0.4s0.5,0.1,0.8,0.1c0.2,0,0.5,0,0.7-0.1c0.2-0.1,0.5-0.1,0.7-0.2c0.2-0.1,0.4-0.2,0.7-0.4s0.4-0.3,0.6-0.4
        s0.3-0.3,0.5-0.4c0.2-0.2,0.4-0.3,0.4-0.4C16.7,9.7,18.7,8.2,19.6,7.5z"
          />
        );
      case "tent":
        return (
          <path
            d="M19.5,16c0.1,0,0.3,0,0.4,0.1s0.1,0.2,0.1,0.4v1c0,0.1,0,0.3-0.1,0.4S19.6,18,19.5,18h-19c-0.1,0-0.3,0-0.4-0.1
        S0,17.7,0,17.5v-1c0-0.1,0-0.3,0.1-0.4S0.4,16,0.5,16h0.8L8.8,5.7L7.1,3.4C6.9,3.1,6.9,2.9,7.2,2.7L8,2.1C8.3,1.9,8.5,2,8.7,2.2
        L10,4l1.3-1.8C11.5,2,11.7,1.9,12,2.1l0.8,0.6c0.3,0.2,0.3,0.4,0.1,0.7l-1.7,2.3L18.7,16H19.5z M10,11l-3.6,5h7.2L10,11z"
          />
        );
      case "feedback":
        return (
          <path
            d="M2.9,3.6C4.9,2,7.2,1.3,10,1.3c2.8,0,5.1,0.8,7.1,2.4C19,5.2,20,7.1,20,9.4c0,2.2-1,4.2-2.9,5.7c-2,1.6-4.3,2.4-7.1,2.4
        c-1.5,0-2.9-0.2-4.2-0.7c-1.7,1.3-3.5,2-5.5,2c-0.1,0-0.1,0-0.2-0.1c-0.1,0-0.1-0.1-0.1-0.1c-0.1-0.1,0-0.2,0.1-0.3
        c0.1-0.1,0.2-0.3,0.5-0.5c0.2-0.3,0.5-0.7,0.9-1.4c0.4-0.6,0.6-1.2,0.8-1.8C0.7,13,0,11.3,0,9.4C0,7.1,1,5.2,2.9,3.6z M4.1,10.3
        c0.2,0.2,0.5,0.4,0.9,0.4c0.3,0,0.6-0.1,0.9-0.4C6.1,10,6.2,9.7,6.2,9.4c0-0.3-0.1-0.6-0.4-0.9C5.6,8.2,5.3,8.1,5,8.1
        c-0.3,0-0.6,0.1-0.9,0.4C3.9,8.7,3.7,9,3.7,9.4C3.7,9.7,3.9,10,4.1,10.3z M9.1,10.3c0.2,0.2,0.5,0.4,0.9,0.4c0.3,0,0.6-0.1,0.9-0.4
        c0.2-0.2,0.4-0.5,0.4-0.9c0-0.3-0.1-0.6-0.4-0.9c-0.2-0.2-0.5-0.4-0.9-0.4c-0.3,0-0.6,0.1-0.9,0.4C8.9,8.7,8.7,9,8.7,9.4
        C8.7,9.7,8.9,10,9.1,10.3z M14.1,10.3c0.2,0.2,0.5,0.4,0.9,0.4c0.3,0,0.6-0.1,0.9-0.4c0.2-0.2,0.4-0.5,0.4-0.9
        c0-0.3-0.1-0.6-0.4-0.9c-0.2-0.2-0.5-0.4-0.9-0.4c-0.3,0-0.6,0.1-0.9,0.4c-0.2,0.2-0.4,0.5-0.4,0.9C13.8,9.7,13.9,10,14.1,10.3z"
          />
        );
      case "password":
        return (
          <path
            d="M20,7c0,1.9-0.7,3.5-2,4.9c-1.3,1.3-3,2-4.9,2c-0.4,0-0.9,0-1.3-0.1l-0.9,1.1c-0.2,0.2-0.4,0.3-0.7,0.3H8.8v1.6
        c0,0.3-0.1,0.5-0.3,0.7c-0.2,0.2-0.4,0.3-0.7,0.3H6.3v1.6c0,0.3-0.1,0.5-0.3,0.7c-0.2,0.2-0.4,0.3-0.7,0.3H0.9
        c-0.3,0-0.5-0.1-0.7-0.3C0.1,19.7,0,19.4,0,19.2v-3c0-0.3,0.1-0.5,0.3-0.7l6.3-6.3C6.4,8.4,6.3,7.7,6.3,7c0-1.2,0.3-2.4,0.9-3.5
        C7.8,2.5,8.6,1.6,9.7,1s2.2-0.9,3.5-0.9c1.9,0,3.5,0.7,4.9,2C19.3,3.5,20,5.1,20,7z M13.7,3.8c-0.4,0.4-0.5,0.8-0.5,1.3
        c0,0.5,0.2,1,0.5,1.3C14,6.8,14.5,7,15,7c0.5,0,1-0.2,1.3-0.5c0.4-0.4,0.5-0.8,0.5-1.3c0-0.5-0.2-1-0.5-1.3C16,3.4,15.5,3.2,15,3.2
        C14.5,3.2,14,3.4,13.7,3.8z"
          />
        );
      case "attachment":
        return (
          <g>
            <path d="M15,3 L7,3 C3.13400675,3 0,6.13400675 0,10 C0,13.8659932 3.13400675,17 7,17 L15,17 L15,15 L9.44949137,15 L7,15 C4.23857625,15 2,12.7614237 2,10 C2,7.23857625 4.23857625,5 7,5 L9.44949137,5 L12.9998169,5 L15,5 C16.6568542,5 18,6.34314575 18,8 C18,9.65685425 16.6568542,11 15,11 L12.9998169,11 L8.41464715,11 L7,11 C6.44771525,11 6,10.5522847 6,10 C6,9.44771525 6.44771525,9 7,9 L8.41464715,9 L15,9 L15,7 L7,7 C5.34314575,7 4,8.34314575 4,10 C4,11.6568542 5.34314575,13 7,13 L15,13 C17.7614237,13 20,10.7614237 20,8 C20,5.23857625 17.7614237,3 15,3 Z" />
          </g>
        );
      case "eye-open":
        return (
          <g>
            <path
              d="M19.8,9.5C19.9,9.7,20,10,20,10.3s-0.1,0.6-0.2,0.8c-1,1.7-2.3,3-4.1,4c-1.7,1-3.6,1.5-5.7,1.5c-2.1,0-4-0.5-5.7-1.5
        c-1.7-1-3.1-2.3-4.1-4C0.1,10.9,0,10.6,0,10.3s0.1-0.6,0.2-0.8c1-1.7,2.4-3,4.1-4C6,4.4,7.9,3.9,10,3.9c2.1,0,4,0.5,5.7,1.5
        C17.4,6.4,18.8,7.8,19.8,9.5z M10,15c1.8,0,3.4-0.4,4.8-1.3c1.5-0.9,2.6-2,3.5-3.4c-0.5-0.9-1.2-1.7-2-2.3
        c-0.8-0.7-1.7-1.2-2.6-1.6c0.6,0.9,1,1.8,1,2.9c0,0.9-0.2,1.6-0.6,2.4c-0.4,0.7-1,1.3-1.7,1.7c-0.7,0.4-1.5,0.6-2.4,0.6
        s-1.6-0.2-2.4-0.6c-0.7-0.4-1.3-1-1.7-1.7C5.5,10.8,5.3,10,5.3,9.2c0-0.8,0.2-1.5,0.6-2.2c0,0.5,0.2,1,0.6,1.4
        c0.4,0.4,0.8,0.6,1.4,0.6s1-0.2,1.4-0.6C9.5,8,9.7,7.5,9.7,7S9.5,6,9.2,5.6c-1.6,0.1-3,0.6-4.3,1.5C3.5,7.9,2.5,9,1.7,10.3
        c0.9,1.4,2,2.6,3.5,3.4C6.6,14.6,8.2,15,10,15z"
            />
          </g>
        );
      case "eye-closed":
        return (
          <g>
            <path
              d="M10,15h0.3l1.1,1.6c-0.5,0-0.9,0.1-1.4,0.1c-2.1,0-4-0.5-5.7-1.5c-1.7-1-3.1-2.3-4.1-4C0.1,10.9,0,10.6,0,10.3
        s0.1-0.6,0.2-0.8C1.1,8,2.3,6.7,3.8,5.8l0.9,1.4C3.4,7.9,2.4,9,1.7,10.3c0.9,1.4,2,2.6,3.5,3.4C6.6,14.6,8.2,15,10,15z M19.8,11.1
        c0.2-0.3,0.2-0.5,0.2-0.8s-0.1-0.6-0.2-0.8c-1-1.7-2.3-3-4.1-4c-1.7-1-3.6-1.5-5.7-1.5c-1.1,0-2.1,0.1-3.1,0.4L4.9,1.6
        c0-0.1-0.1-0.2-0.2-0.2s-0.2,0-0.3,0.1L3.6,2C3.6,2.1,3.5,2.2,3.5,2.3c0,0.1,0,0.2,0.1,0.3L15.1,19c0,0.1,0.1,0.2,0.2,0.2
        c0.1,0,0.2,0,0.3-0.1l0.7-0.5c0.1-0.1,0.2-0.2,0.2-0.3c0-0.1,0-0.2-0.1-0.3l-1.7-2.4c1-0.5,2-1.1,2.8-1.9
        C18.5,13,19.2,12.1,19.8,11.1z M9.5,13.9L5.4,8.1C5.2,9,5.2,9.9,5.5,10.7c0.3,0.9,0.8,1.6,1.5,2.2C7.7,13.5,8.6,13.8,9.5,13.9z
         M18.3,10.3c-0.5,0.9-1.2,1.7-1.9,2.3c-0.8,0.7-1.6,1.2-2.6,1.6l-0.9-1.3c0.9-0.7,1.5-1.6,1.7-2.8C14.9,9,14.7,8,14.2,7
        c0,0.5-0.2,1-0.6,1.4c-0.4,0.4-0.8,0.6-1.4,0.6s-1-0.2-1.4-0.6C10.5,8,10.3,7.5,10.3,7s0.2-1,0.6-1.4c1.6,0.1,3,0.6,4.3,1.5
        C16.5,7.9,17.5,9,18.3,10.3z"
            />
          </g>
        );
      case "lock-open":
        return (
          <g fillRule="evenodd">
            <path d="M11,14.7324356 C11.5978014,14.3866262 12,13.7402824 12,13 C12,11.8954305 11.1045695,11 10,11 C8.8954305,11 8,11.8954305 8,13 C8,13.7402824 8.40219863,14.3866262 9,14.7324356 L9,17 L11,17 L11,14.7324356 Z M13,6 C13,4.34314575 11.6568542,3 10,3 C8.34314575,3 7,4.34314575 7,6 L7,8 L13,8 L13,6 Z M4,8 L4,6 C4,2.6862915 6.6862915,0 10,0 C13.3137085,0 16,2.6862915 16,6 L13,6 L13,8 L17.0049107,8 C18.1067681,8 19,8.90195036 19,10.0085302 L19,17.9914698 C19,19.1007504 18.1073772,20 17.0049107,20 L2.99508929,20 C1.8932319,20 1,19.0980496 1,17.9914698 L1,10.0085302 C1,8.8992496 1.8926228,8 2.99508929,8 L4,8 Z" />
          </g>
        );
      case "lock-closed":
        return (
          <g>
            <path d="M11,14.7324356 C11.5978014,14.3866262 12,13.7402824 12,13 C12,11.8954305 11.1045695,11 10,11 C8.8954305,11 8,11.8954305 8,13 C8,13.7402824 8.40219863,14.3866262 9,14.7324356 L9,17 L11,17 L11,14.7324356 Z M13,6 C13,4.34314575 11.6568542,3 10,3 C8.34314575,3 7,4.34314575 7,6 L7,8 L13,8 L13,6 Z M4,8 L4,6 C4,2.6862915 6.6862915,0 10,0 C13.3137085,0 16,2.6862915 16,6 L16,8 L17.0049107,8 C18.1067681,8 19,8.90195036 19,10.0085302 L19,17.9914698 C19,19.1007504 18.1073772,20 17.0049107,20 L2.99508929,20 C1.8932319,20 1,19.0980496 1,17.9914698 L1,10.0085302 C1,8.8992496 1.8926228,8 2.99508929,8 L4,8 Z" />
          </g>
        );
      case "open-issue":
        return (
          <g>
            <path
              fillRule="evenodd"
              d="M7 2.3c3.14 0 5.7 2.56 5.7 5.7s-2.56 5.7-5.7 5.7A5.71 5.71 0 0 1 1.3 8c0-3.14 2.56-5.7 5.7-5.7zM7 1C3.14 1 0 4.14 0 8s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zm1 3H6v5h2V4zm0 6H6v2h2v-2z"
            />
          </g>
        );
      case "closed-issue":
        return (
          <g>
            <path
              fillRule="evenodd"
              d="M7 10h2v2H7v-2zm2-6H7v5h2V4zm1.5 1.5l-1 1L12 9l4-4.5-1-1L12 7l-1.5-1.5zM8 13.7A5.71 5.71 0 0 1 2.3 8c0-3.14 2.56-5.7 5.7-5.7 1.83 0 3.45.88 4.5 2.2l.92-.92A6.947 6.947 0 0 0 8 1C4.14 1 1 4.14 1 8s3.14 7 7 7 7-3.14 7-7l-1.52 1.52c-.66 2.41-2.86 4.19-5.48 4.19v-.01z"
            />
          </g>
        );
      case "menu":
        return (
          <g>
            <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
          </g>
        );
      case "exclamation":
        return (
          <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
            <path d="M2.92893219,17.0710678 C6.83417511,20.9763107 13.1658249,20.9763107 17.0710678,17.0710678 C20.9763107,13.1658249 20.9763107,6.83417511 17.0710678,2.92893219 C13.1658249,-0.976310729 6.83417511,-0.976310729 2.92893219,2.92893219 C-0.976310729,6.83417511 -0.976310729,13.1658249 2.92893219,17.0710678 Z M9,5 L11,5 L11,11 L9,11 L9,5 Z M9,13 L11,13 L11,15 L9,15 L9,13 Z" />
          </g>
        );
      case "wechat":
        return (
          <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
            <circle cx="9.7" cy="7.2" r="0.7" />
            <circle cx="6.4" cy="7.2" r="0.7" />
            <circle cx="14.2" cy="10.6" r="0.6" />
            <circle cx="11.4" cy="10.6" r="0.6" />
            <path
              d="M10,0C4.5,0,0,4.5,0,10c0,5.5,4.5,10,10,10c5.5,0,10-4.5,10-10C20,4.5,15.5,0,10,0z M8.4,12.3c-0.5,0-0.9-0.1-1.4-0.2
        l-0.1,0c-0.1,0-0.2,0-0.2,0.1l-0.9,0.5l-0.1,0c-0.1,0-0.1-0.1-0.1-0.1l0-0.1l0.2-0.7l0-0.1c0-0.1,0-0.2-0.1-0.2
        c-0.9-0.6-1.5-1.6-1.5-2.7c0-1.9,1.9-3.5,4.2-3.5c2.1,0,3.8,1.3,4.2,3l-0.2,0c-2.1,0-3.8,1.4-3.8,3.2c0,0.3,0,0.6,0.1,0.9L8.4,12.3
        z M14.6,13.7c-0.1,0-0.1,0.1-0.1,0.2l0,0.1l0.2,0.6l0,0.1c0,0.1-0.1,0.1-0.1,0.1l-0.1,0l-0.8-0.4c-0.1,0-0.1-0.1-0.2-0.1l-0.1,0
        c-0.4,0.1-0.7,0.2-1.1,0.2c-1.9,0-3.5-1.3-3.5-2.9c0-1.6,1.6-2.9,3.5-2.9c1.9,0,3.5,1.3,3.5,2.9C15.8,12.3,15.4,13.1,14.6,13.7z"
            />
          </g>
        );
      case "alipay":
        return (
          <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
            <path
              d="M20,10c0-1.5-0.3-2.9-0.9-4.2c-1-2.2-2.7-3.9-4.9-4.9C12.9,0.3,11.5,0,10,0S7.1,0.3,5.8,0.9c-2.2,1-3.9,2.7-4.9,4.9
        C0.3,7.1,0,8.5,0,10s0.3,2.9,0.9,4.2c1,2.2,2.7,3.9,4.9,4.9C7.1,19.7,8.5,20,10,20s2.9-0.3,4.2-0.9c1.5-0.7,2.8-1.8,3.8-3.1
        c-1.7-0.9-3.9-1.9-6-2.8c-1.3,1.8-3.5,3.3-6.1,3.3c-2.9,0-3.8-1.9-4-3.1C1.8,11.8,2.6,10,6,10c1.4,0,3.3,0.4,5.2,1
        c0.5-0.9,0.9-2.1,1-2.5c-0.7,0-7.3,0-7.3,0v-1h4v-1H4.5v-1H9v-2l2,0v2h4.5v1H11v1h3.5c0,0-0.5,2.3-1.6,4.1c2,0.7,4.1,1.2,6.1,1.9
        l0.2,0.1C19.7,12.5,20,11.3,20,10z"
            />
            <path d="M2.6,13.2c0,0.8,0.4,2.2,2.9,2.2c2.1,0,3.8-1.6,4.8-3c-1.8-0.8-3.5-1.3-4.5-1.3C3.1,11.1,2.6,12.5,2.6,13.2z" />
          </g>
        );
      case "question":
        return (
          <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
            <path d="M14,7 C14,7.81404368 13.5749107,8.83930284 12.9961487,9.4180649 L11.4180649,10.9961487 C11.2143227,11.1998909 11,11.7148676 11,12 L11,13 L9,13 L9,12 C9,11.1832235 9.42588582,10.1599006 10.0038513,9.5819351 L11.5819351,8.00385134 C11.7857992,7.79998728 12,7.28336316 12,7 C12,5.8954305 11.1045695,5 10,5 C8.8954305,5 8,5.8954305 8,7 L6,7 C6,4.790861 7.790861,3 10,3 C12.209139,3 14,4.790861 14,7 Z M10,20 C15.5228475,20 20,15.5228475 20,10 C20,4.4771525 15.5228475,0 10,0 C4.4771525,0 0,4.4771525 0,10 C0,15.5228475 4.4771525,20 10,20 Z M9,15 L11,15 L11,17 L9,17 L9,15 Z" />
          </g>
        );
      case "prepaid":
      case "cash":
        return (
          <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
            <path d="M10,20 C15.5228475,20 20,15.5228475 20,10 C20,4.4771525 15.5228475,0 10,0 C4.4771525,0 0,4.4771525 0,10 C0,15.5228475 4.4771525,20 10,20 Z M11,15 L11,17 L9,17 L9,15 L6,15 L6,13 L10.5838882,13 L11.9970707,13 C12.5621186,13 13,12.5522847 13,12 C13,11.4438648 12.5509732,11 11.9970707,11 L10.5838882,11 L8,11 C6.34314575,11 5,9.65685425 5,8 C5,6.34314575 6.34314575,5 8,5 L9,5 L9,3 L11,3 L11,5 L14,5 L14,7 L9.41464715,7 L7.99077797,7 C7.45097518,7 7,7.44771525 7,8 C7,8.55613518 7.44358641,9 7.99077797,9 L9.41464715,9 L12,9 C13.6568542,9 15,10.3431458 15,12 C15,13.6568542 13.6568542,15 12,15 L11,15 Z" />
          </g>
        );
      case "up":
        return (
          <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
            <polygon points="10.7071068 7.05025253 10 6.34314575 4.34314575 12 5.75735931 13.4142136 10 9.17157288 14.2426407 13.4142136 15.6568542 12" />
          </g>
        );
      case "down":
        return (
          <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
            <polygon points="9.29289322 12.9497475 10 13.6568542 15.6568542 8 14.2426407 6.58578644 10 10.8284271 5.75735931 6.58578644 4.34314575 8" />
          </g>
        );
      case "left":
        return (
          <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
            <polygon points="7.05025253 9.29289322 6.34314575 10 12 15.6568542 13.4142136 14.2426407 9.17157288 10 13.4142136 5.75735931 12 4.34314575" />
          </g>
        );
      case "right":
        return (
          <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
            <polygon points="12.9497475 10.7071068 13.6568542 10 8 4.34314575 6.58578644 5.75735931 10.8284271 10 6.58578644 14.2426407 8 15.6568542 12.9497475 10.7071068" />
          </g>
        );
      case "archive":
        return (
          <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
            <path d="M0,2 C0,0.8954305 0.898212381,0 1.99079514,0 L18.0092049,0 C19.1086907,0 20,0.887729645 20,2 L20,4 L0,4 L0,2 Z M1,5 L19,5 L19,18.0081158 C19,19.1082031 18.1073772,20 17.0049107,20 L2.99508929,20 C1.8932319,20 1,19.1066027 1,18.0081158 L1,5 Z M7,7 L13,7 L13,9 L7,9 L7,7 Z" />
          </g>
        );
      case "credit-card":
        return (
          <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
            <path d="M0,3.99406028 C0,2.8927712 0.898212381,2 1.99079514,2 L18.0092049,2 C19.1086907,2 20,2.89451376 20,3.99406028 L20,16.0059397 C20,17.1072288 19.1017876,18 18.0092049,18 L1.99079514,18 C0.891309342,18 0,17.1054862 0,16.0059397 L0,3.99406028 Z M2,4 L18,4 L18,16 L2,16 L2,4 Z M2,6 L18,6 L18,10 L2,10 L2,6 Z M4,12 L8,12 L8,14 L4,14 L4,12 Z" />
          </g>
        );
      case "staff":
        return (
          <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
            <path
              d="M5.4,10.6c-0.6,0.3-1.1,0.8-1.6,1.4c-0.4,0.6-0.7,1.3-0.8,2H1c-0.3,0-0.5-0.1-0.7-0.3C0.1,13.5,0,13.3,0,13v-1
        c0-0.5,0.2-1,0.6-1.4C1,10.2,1.5,10,2,10h2C4.5,10,5,10.2,5.4,10.6z M4.4,8.4C4,8.8,3.5,9,3,9C2.5,9,2,8.8,1.6,8.4C1.2,8,1,7.5,1,7
        c0-0.5,0.2-1,0.6-1.4C2,5.2,2.5,5,3,5c0.5,0,1,0.2,1.4,0.6C4.8,6,5,6.5,5,7C5,7.5,4.8,8,4.4,8.4z M12.4,11c1,0,1.8,0.3,2.5,1
        c0.7,0.7,1,1.5,1,2.5v0.9c0,0.4-0.1,0.8-0.4,1.1c-0.3,0.3-0.6,0.4-1.1,0.4h-9c-0.4,0-0.8-0.1-1.1-0.4C4.1,16.3,4,15.9,4,15.5v-0.9
        c0-1,0.3-1.8,1-2.5c0.7-0.7,1.5-1,2.5-1h0.3c0.7,0.3,1.4,0.5,2.1,0.5c0.7,0,1.4-0.2,2.1-0.5H12.4z M12.5,9c-0.7,0.7-1.5,1-2.5,1
        c-1,0-1.8-0.3-2.5-1s-1-1.5-1-2.5c0-1,0.3-1.8,1-2.5S9,3,10,3c1,0,1.8,0.3,2.5,1s1,1.5,1,2.5C13.5,7.5,13.2,8.3,12.5,9z M18,10
        c0.5,0,1,0.2,1.4,0.6C19.8,11,20,11.5,20,12v1c0,0.3-0.1,0.5-0.3,0.7C19.5,13.9,19.3,14,19,14h-2.1c-0.1-0.5-0.2-0.9-0.4-1.4
        c-0.2-0.4-0.5-0.8-0.8-1.2c-0.3-0.3-0.7-0.6-1.1-0.9C15,10.2,15.5,10,16,10H18z M18.4,8.4C18,8.8,17.5,9,17,9c-0.5,0-1-0.2-1.4-0.6
        C15.2,8,15,7.5,15,7c0-0.5,0.2-1,0.6-1.4C16,5.2,16.5,5,17,5c0.5,0,1,0.2,1.4,0.6C18.8,6,19,6.5,19,7C19,7.5,18.8,8,18.4,8.4z"
            />
          </g>
        );
      case "client":
        return (
          <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
            <path
              d="M13.8,11.3c1.4,0.1,2.6,0.6,3.5,1.6s1.5,2.2,1.5,3.6v1.6c0,0.5-0.2,1-0.5,1.3c-0.4,0.4-0.8,0.5-1.3,0.5H3.1
        c-0.5,0-1-0.2-1.3-0.5c-0.4-0.4-0.5-0.8-0.5-1.3v-1.6c0-1.4,0.5-2.6,1.5-3.6s2.2-1.5,3.5-1.6l1.9,7.5l1.2-5.3l-1.2-2.2h3.8
        l-1.2,2.2l1.2,5.3L13.8,11.3z M13.5,8.5c-1,1-2.2,1.5-3.5,1.5c-1.4,0-2.6-0.5-3.5-1.5S5,6.4,5,5c0-1.4,0.5-2.6,1.5-3.5S8.6,0,10,0
        c1.4,0,2.6,0.5,3.5,1.5S15,3.6,15,5C15,6.4,14.5,7.6,13.5,8.5z"
            />
          </g>
        );
      case "user":
        return (
          <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
            <path d="M10,20 C15.5228475,20 20,15.5228475 20,10 C20,4.4771525 15.5228475,0 10,0 C4.4771525,0 0,4.4771525 0,10 C0,15.5228475 4.4771525,20 10,20 Z M6.99999861,6.00166547 C6.99999861,4.34389141 8.3465151,3 9.99999722,3 C11.6568507,3 12.9999958,4.33902013 12.9999958,6.00166547 L12.9999958,7.99833453 C12.9999958,9.65610859 11.6534793,11 9.99999722,11 C8.34314374,11 6.99999861,9.66097987 6.99999861,7.99833453 L6.99999861,6.00166547 Z M3.34715433,14.4444439 C5.37306718,13.5169611 7.62616222,13 10,13 C12.3738388,13 14.6269347,13.5169615 16.6528458,14.4444437 C15.2177146,16.5884188 12.7737035,18 10,18 C7.22629656,18 4.78228556,16.5884189 3.34715433,14.4444439 L3.34715433,14.4444439 Z" />
          </g>
        );
      case "user-square":
        return (
          <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
            <path d="M0,1.99079514 C0,0.891309342 0.898212381,0 1.99079514,0 L18.0092049,0 C19.1086907,0 20,0.898212381 20,1.99079514 L20,18.0092049 C20,19.1086907 19.1017876,20 18.0092049,20 L1.99079514,20 C0.891309342,20 0,19.1017876 0,18.0092049 L0,1.99079514 Z M6.99999861,6.00166547 C6.99999861,4.34389141 8.3465151,3 9.99999722,3 C11.6568507,3 12.9999958,4.33902013 12.9999958,6.00166547 L12.9999958,7.99833453 C12.9999958,9.65610859 11.6534793,11 9.99999722,11 C8.34314374,11 6.99999861,9.66097987 6.99999861,7.99833453 L6.99999861,6.00166547 Z M18.0000045,15.1405177 C15.6466165,13.7791553 12.914299,13 10,13 C7.08570101,13 4.35338349,13.7791553 1.99999555,15.1405177 L2,18 L18,18 L18,15.1405151 L18.0000045,15.1405177 Z" />
          </g>
        );
      case "trash":
        return (
          <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
            <path d="M2,2 L18,2 L18,4 L2,4 L2,2 Z M8,0 L12,0 L14,2 L6,2 L8,0 Z M3,6 L17,6 L16,20 L4,20 L3,6 Z M8,8 L9,8 L9,18 L8,18 L8,8 Z M11,8 L12,8 L12,18 L11,18 L11,8 Z" />
          </g>
        );
      case "deleted":
        return (
          <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
            <path d="M2,2 L18,2 L18,4 L2,4 L2,2 Z M8,0 L12,0 L14,2 L6,2 L8,0 Z M3,6 L17,6 L16,20 L4,20 L3,6 Z M8,8 L9,8 L9,18 L8,18 L8,8 Z M11,8 L12,8 L12,18 L11,18 L11,8 Z" />
          </g>
        );
      case "show":
        return (
          <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
            <path d="M19.8005808,10 C17.9798698,6.43832409 14.2746855,4 10,4 C5.72531453,4 2.02013017,6.43832409 0.199419187,10 C2.02013017,13.5616759 5.72531453,16 10,16 C14.2746855,16 17.9798698,13.5616759 19.8005808,10 Z M10,14 C12.209139,14 14,12.209139 14,10 C14,7.790861 12.209139,6 10,6 C7.790861,6 6,7.790861 6,10 C6,12.209139 7.790861,14 10,14 Z M10,12 C11.1045695,12 12,11.1045695 12,10 C12,8.8954305 11.1045695,8 10,8 C8.8954305,8 8,8.8954305 8,10 C8,11.1045695 8.8954305,12 10,12 Z" />
          </g>
        );
      case "domino":
        return (
          <g>
            <path
              style={{ fill: "#444444" }}
              d="M0,15.8c0-2.5,1.9-4.4,4.4-4.4c2.4,0,4.3,1.9,4.3,4.4c0,2.4-2,4.4-4.4,4.4C1.9,20.2,0,18.3,0,15.8z"
            />
            <path
              style={{ fill: "#444444" }}
              d="M0,4.4C0,1.9,1.9,0,4.4,0c2.5,0,4.4,1.9,4.4,4.4c0,2.4-1.9,4.4-4.4,4.4C1.9,8.8,0,6.9,0,4.4z"
            />
            <path
              style={{ fill: "#444444" }}
              d="M20.2,4.4c0,2.5-1.9,4.4-4.4,4.4c-2.4,0-4.4-1.9-4.4-4.4c0-2.5,1.9-4.4,4.4-4.4
                        C18.3,0,20.2,1.9,20.2,4.4z"
            />
            <path
              style={{ fill: "#E6292F" }}
              d="M20.2,15.8c0,2.4-1.9,4.4-4.4,4.4c-2.4,0-4.4-1.9-4.4-4.4c0-2.5,1.9-4.4,4.4-4.4
                        C18.3,11.5,20.2,13.3,20.2,15.8z"
            />
          </g>
        );
      case "delete":
        return (
          <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
            <path d="M11.4142136,10 L14.2426407,7.17157288 L12.8284271,5.75735931 L10,8.58578644 L7.17157288,5.75735931 L5.75735931,7.17157288 L8.58578644,10 L5.75735931,12.8284271 L7.17157288,14.2426407 L10,11.4142136 L12.8284271,14.2426407 L14.2426407,12.8284271 L11.4142136,10 L11.4142136,10 Z M2.92893219,17.0710678 C6.83417511,20.9763107 13.1658249,20.9763107 17.0710678,17.0710678 C20.9763107,13.1658249 20.9763107,6.83417511 17.0710678,2.92893219 C13.1658249,-0.976310729 6.83417511,-0.976310729 2.92893219,2.92893219 C-0.976310729,6.83417511 -0.976310729,13.1658249 2.92893219,17.0710678 L2.92893219,17.0710678 Z" />
          </g>
        );
      case "close-outline":
        return (
          <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
            <path d="M11.4142136,10 L14.2426407,7.17157288 L12.8284271,5.75735931 L10,8.58578644 L7.17157288,5.75735931 L5.75735931,7.17157288 L8.58578644,10 L5.75735931,12.8284271 L7.17157288,14.2426407 L10,11.4142136 L12.8284271,14.2426407 L14.2426407,12.8284271 L11.4142136,10 L11.4142136,10 Z M2.92893219,17.0710678 C6.83417511,20.9763107 13.1658249,20.9763107 17.0710678,17.0710678 C20.9763107,13.1658249 20.9763107,6.83417511 17.0710678,2.92893219 C13.1658249,-0.976310729 6.83417511,-0.976310729 2.92893219,2.92893219 C-0.976310729,6.83417511 -0.976310729,13.1658249 2.92893219,17.0710678 L2.92893219,17.0710678 Z M4.34314575,15.6568542 C7.46734008,18.7810486 12.5326599,18.7810486 15.6568542,15.6568542 C18.7810486,12.5326599 18.7810486,7.46734008 15.6568542,4.34314575 C12.5326599,1.21895142 7.46734008,1.21895142 4.34314575,4.34314575 C1.21895142,7.46734008 1.21895142,12.5326599 4.34314575,15.6568542 L4.34314575,15.6568542 Z" />
          </g>
        );
      case "close":
        return (
          <g>
            <path d="M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z" />
          </g>
        );
      case "map":
        return (
          <g>
            <path d="M0 0l6 4 8-4 6 4v16l-6-4-8 4-6-4V0zm7 6v11l6-3V3L7 6z" />
          </g>
        );
      case "book":
        return (
          <g>
            <path d="M2 2c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v18l-8-4-8 4V2zm2 0v15l6-3 6 3V2H4z" />
          </g>
        );
      case "play":
        return (
          <g>
            <path d="M4 4l12 6-12 6z" />
          </g>
        );
      case "play-outline":
        return (
          <g>
            <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM7 6l8 4-8 4V6z" />
          </g>
        );
      case "tick":
        return (
          <g>
            <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
          </g>
        );
      case "pause":
        return (
          <g>
            <path d="M5 4h3v12H5V4zm7 0h3v12h-3V4z" />
          </g>
        );
      case "plane":
        return (
          <g>
            <path d="M8.4 12H2.8L1 15H0V5h1l1.8 3h5.6L6 0h2l4.8 8H18a2 2 0 1 1 0 4h-5.2L8 20H6l2.4-8z" />
          </g>
        );
      case "volume":
        return (
          <g>
            <path d="M5 7H1v6h4l5 5V2L5 7zm11.36 9.36l-1.41-1.41a6.98 6.98 0 0 0 0-9.9l1.41-1.41a8.97 8.97 0 0 1 0 12.72zm-2.82-2.82l-1.42-1.42a3 3 0 0 0 0-4.24l1.42-1.42a4.98 4.98 0 0 1 0 7.08z" />
          </g>
        );
      case "muted":
        return (
          <g>
            <path d="M9 7H5v6h4l5 5V2L9 7z" />
          </g>
        );
      case "document":
        return (
          <g>
            <path
              d="M11.2,5.3c0,0.3,0.1,0.5,0.3,0.7c0.2,0.2,0.4,0.3,0.7,0.3h5.3v12.8c0,0.3-0.1,0.5-0.3,0.7C17,19.9,16.8,20,16.6,20H3.4
        c-0.3,0-0.5-0.1-0.7-0.3c-0.2-0.2-0.3-0.4-0.3-0.7V0.9c0-0.3,0.1-0.5,0.3-0.7C3,0.1,3.2,0,3.4,0h7.8V5.3z M13.8,9.2
        c0-0.3-0.2-0.5-0.5-0.5H6.7c-0.3,0-0.5,0.2-0.5,0.5v0.3c0,0.3,0.2,0.5,0.5,0.5h6.6c0.3,0,0.5-0.2,0.5-0.5V9.2z M13.8,12v-0.3
        c0-0.3-0.2-0.5-0.5-0.5H6.7c-0.3,0-0.5,0.2-0.5,0.5V12c0,0.3,0.2,0.5,0.5,0.5h6.6C13.6,12.5,13.8,12.3,13.8,12z M13.8,14.5v-0.3
        c0-0.3-0.2-0.5-0.5-0.5H6.7c-0.3,0-0.5,0.2-0.5,0.5v0.3c0,0.3,0.2,0.5,0.5,0.5h6.6C13.6,15,13.8,14.8,13.8,14.5z M17.5,4.8V5h-5V0
        h0.2c0.3,0,0.5,0.1,0.7,0.3l3.8,3.8C17.4,4.3,17.5,4.5,17.5,4.8z"
            />
          </g>
        );
      case "skill":
        return (
          <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
            <path
              d="M19.5,13c0.1,0,0.3,0,0.4,0.1s0.1,0.2,0.1,0.4v1c0,0.1,0,0.3-0.1,0.4S19.6,15,19.5,15H19c-1.2,0-2.2-0.3-3-1
        c-0.8,0.7-1.8,1-3,1c-1.2,0-2.2-0.3-3-1c-0.8,0.7-1.8,1-3,1c-1.2,0-2.2-0.3-3-1c-0.8,0.7-1.8,1-3,1H0.5c-0.1,0-0.3,0-0.4-0.1
        S0,14.7,0,14.5v-1c0-0.1,0-0.3,0.1-0.4S0.4,13,0.5,13H1c0.8,0,1.4-0.2,1.8-0.6c0.3-0.3,0.6-0.4,1-0.4h0.5c0.4,0,0.7,0.1,1,0.4
        C5.6,12.8,6.2,13,7,13c0.8,0,1.4-0.2,1.8-0.6c0.3-0.3,0.6-0.4,1-0.4h0.5c0.4,0,0.7,0.1,1,0.4c0.4,0.4,1,0.6,1.8,0.6
        c0.8,0,1.4-0.2,1.8-0.6c0.3-0.3,0.6-0.4,1-0.4h0.5c0.4,0,0.7,0.1,1,0.4c0.4,0.4,1,0.6,1.8,0.6H19.5z M5.3,9.3
        C4.8,9.8,4.2,10,3.5,10S2.2,9.8,1.7,9.3C1.2,8.8,1,8.2,1,7.5s0.2-1.3,0.7-1.8C2.2,5.3,2.8,5,3.5,5s1.3,0.2,1.8,0.7
        C5.8,6.2,6,6.8,6,7.5S5.8,8.8,5.3,9.3z M5.9,11.7c-0.1-0.1-0.3-0.3-0.5-0.4l2.1-3.1C7.8,8,8.1,7.7,8.4,7.4l2.5-1.8
        c0.8-0.6,1.8-0.8,2.8-0.6l3.1,0.7c0.4,0.1,0.7,0.3,0.9,0.7C18,6.8,18.1,7.1,18,7.5c-0.1,0.4-0.3,0.7-0.7,0.9
        c-0.4,0.2-0.7,0.3-1.1,0.2L13.1,8c-0.1,0-0.3,0-0.4,0.1l-0.6,0.4l3.5,2.5c-0.6,0-1.1,0.3-1.6,0.7C13.9,11.9,13.5,12,13,12
        s-0.9-0.1-1.1-0.3c-0.5-0.5-1.1-0.7-1.7-0.7H9.8c-0.6,0-1.2,0.2-1.7,0.7C7.9,11.9,7.5,12,7,12S6.1,11.9,5.9,11.7z"
            />
          </g>
        );
      case "camera":
        return (
          <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
            <path
              d="M1.9,1.2h16.2c0.5,0,1,0.2,1.3,0.5C19.8,2.2,20,2.6,20,3.1v13.8c0,0.5-0.2,1-0.5,1.3c-0.4,0.4-0.8,0.5-1.3,0.5H1.9
        c-0.5,0-1-0.2-1.3-0.5C0.2,17.8,0,17.4,0,16.9V3.1c0-0.5,0.2-1,0.5-1.3C0.9,1.4,1.4,1.2,1.9,1.2z M18.5,6.2c0.2,0,0.2-0.1,0.2-0.2
        V3.1c0-0.2-0.1-0.3-0.2-0.4s-0.3-0.2-0.4-0.2H8.2c-0.1,0-0.1,0-0.2,0.1L6.9,4.4H1.5c-0.2,0-0.2,0.1-0.2,0.2V6
        c0,0.2,0.1,0.2,0.2,0.2H18.5z M1.9,2.5c-0.2,0-0.3,0.1-0.4,0.2S1.2,2.9,1.2,3.1v0.4c0,0.2,0.1,0.2,0.2,0.2H6c0.2,0,0.2-0.1,0.2-0.2
        V2.7c0-0.2-0.1-0.2-0.2-0.2H1.9z M6.7,15.2c0.9,0.9,2,1.4,3.3,1.4c1.3,0,2.4-0.5,3.3-1.4c0.9-0.9,1.4-2,1.4-3.3
        c0-1.3-0.5-2.4-1.4-3.3c-0.9-0.9-2-1.4-3.3-1.4c-1.3,0-2.4,0.5-3.3,1.4c-0.9,0.9-1.4,2-1.4,3.3C5.3,13.2,5.8,14.3,6.7,15.2z
         M7.6,9.5c0.7-0.7,1.5-1,2.4-1s1.7,0.3,2.4,1c0.7,0.7,1,1.5,1,2.4s-0.3,1.7-1,2.4c-0.7,0.7-1.5,1-2.4,1s-1.7-0.3-2.4-1
        c-0.7-0.7-1-1.5-1-2.4S6.9,10.1,7.6,9.5z M7.7,12.3c0.1,0.1,0.3,0.2,0.4,0.2c0.2,0,0.3-0.1,0.4-0.2s0.2-0.3,0.2-0.4
        c0-0.3,0.1-0.6,0.4-0.9c0.2-0.2,0.5-0.4,0.9-0.4c0.2,0,0.3-0.1,0.4-0.2s0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4S10.2,9.4,10,9.4
        c-0.7,0-1.3,0.2-1.8,0.7c-0.5,0.5-0.7,1.1-0.7,1.8C7.5,12.1,7.6,12.2,7.7,12.3z"
            />
          </g>
        );
      case "pencil":
      case "edit":
        return (
          <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
            <path d="M2,4 L2,18 L16,18 L16,12 L18,10 L18,20 L17,20 L0,20 L0,19 L0,3 L0,2 L10,2 L8,4 L2,4 Z M12.2928932,3.70710678 L4,12 L4,16 L8,16 L16.2928932,7.70710678 L12.2928932,3.70710678 Z M13.7071068,2.29289322 L16,0 L20,4 L17.7071068,6.29289322 L13.7071068,2.29289322 Z" />
          </g>
        );

      case "cog":
        return (
          <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
            <path d="M3.93830521,6.49683865 C3.63405147,7.02216933 3.39612833,7.5907092 3.23599205,8.19100199 L5.9747955e-16,9 L9.6487359e-16,11 L3.23599205,11.808998 C3.39612833,12.4092908 3.63405147,12.9778307 3.93830521,13.5031614 L2.22182541,16.363961 L3.63603897,17.7781746 L6.49683865,16.0616948 C7.02216933,16.3659485 7.5907092,16.6038717 8.19100199,16.7640079 L9,20 L11,20 L11.808998,16.7640079 C12.4092908,16.6038717 12.9778307,16.3659485 13.5031614,16.0616948 L16.363961,17.7781746 L17.7781746,16.363961 L16.0616948,13.5031614 C16.3659485,12.9778307 16.6038717,12.4092908 16.7640079,11.808998 L20,11 L20,9 L16.7640079,8.19100199 C16.6038717,7.5907092 16.3659485,7.02216933 16.0616948,6.49683865 L17.7781746,3.63603897 L16.363961,2.22182541 L13.5031614,3.93830521 C12.9778307,3.63405147 12.4092908,3.39612833 11.808998,3.23599205 L11,0 L9,0 L8.19100199,3.23599205 C7.5907092,3.39612833 7.02216933,3.63405147 6.49683865,3.93830521 L3.63603897,2.22182541 L2.22182541,3.63603897 L3.93830521,6.49683865 L3.93830521,6.49683865 Z M10,13 C11.6568542,13 13,11.6568542 13,10 C13,8.34314575 11.6568542,7 10,7 C8.34314575,7 7,8.34314575 7,10 C7,11.6568542 8.34314575,13 10,13 L10,13 Z" />
          </g>
        );
      case "updated":
        return (
          <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
            <path d="M2,4 L2,18 L16,18 L16,12 L18,10 L18,20 L17,20 L0,20 L0,19 L0,3 L0,2 L10,2 L8,4 L2,4 Z M12.2928932,3.70710678 L4,12 L4,16 L8,16 L16.2928932,7.70710678 L12.2928932,3.70710678 Z M13.7071068,2.29289322 L16,0 L20,4 L17.7071068,6.29289322 L13.7071068,2.29289322 Z" />
          </g>
        );
      case "trophy":
        return (
          <g>
            <path d="M15 9a3 3 0 0 0 3-3h2a5 5 0 0 1-5.1 5 5 5 0 0 1-3.9 3.9V17l5 2v1H4v-1l5-2v-2.1A5 5 0 0 1 5.1 11H5a5 5 0 0 1-5-5h2a3 3 0 0 0 3 3V4H2v2H0V2h5V0h10v2h5v4h-2V4h-3v5z" />
          </g>
        );
      case "created":
        return (
          <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
            <path d="M11,9 L11,5 L9,5 L9,9 L5,9 L5,11 L9,11 L9,15 L11,15 L11,11 L15,11 L15,9 L11,9 Z M10,20 C15.5228475,20 20,15.5228475 20,10 C20,4.4771525 15.5228475,0 10,0 C4.4771525,0 0,4.4771525 0,10 C0,15.5228475 4.4771525,20 10,20 Z" />
          </g>
        );
      case "chevron-right":
        return (
          <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
            <polygon points="12.9497475 10.7071068 13.6568542 10 8 4.34314575 6.58578644 5.75735931 10.8284271 10 6.58578644 14.2426407 8 15.6568542 12.9497475 10.7071068" />
          </g>
        );
      case "chevron-left":
        return (
          <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
            <polygon points="7.05025253 9.29289322 6.34314575 10 12 15.6568542 13.4142136 14.2426407 9.17157288 10 13.4142136 5.75735931 12 4.34314575" />
          </g>
        );
      case "teacher":
        return (
          <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
            <path
              d="M1.8,3.1C1.4,3,1.2,2.8,1.2,2.5c0-0.3,0.2-0.5,0.5-0.6l7.4-1.8c0.5-0.1,1-0.1,1.6,0l7.4,1.8c0.4,0.1,0.5,0.3,0.5,0.6
        c0,0.3-0.2,0.5-0.5,0.6L14.5,4C14.8,4.8,15,5.5,15,6.2c0,1.4-0.5,2.6-1.5,3.5s-2.2,1.5-3.5,1.5c-1.4,0-2.6-0.5-3.5-1.5S5,7.6,5,6.2
        C5,5.5,5.2,4.8,5.5,4L3,3.4v2.1c0.3,0.2,0.5,0.4,0.5,0.8C3.4,6.6,3.3,6.8,3,7l0.6,2.4c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1-0.1,0.2
        C3.5,10,3.4,10,3.3,10H1.7c-0.1,0-0.2-0.1-0.3-0.2c-0.1-0.1-0.1-0.2,0-0.4L2,7C1.7,6.8,1.6,6.6,1.6,6.2c0-0.3,0.2-0.6,0.5-0.8V3.2
        L1.8,3.1z M13.7,12.5c1.4,0.1,2.6,0.6,3.6,1.6c1,1,1.5,2.2,1.5,3.6v0.4c0,0.5-0.2,1-0.5,1.3c-0.4,0.4-0.8,0.5-1.3,0.5H3.1
        c-0.5,0-1-0.2-1.3-0.5c-0.4-0.4-0.5-0.8-0.5-1.3v-0.4c0-1.4,0.5-2.6,1.5-3.6c1-1,2.2-1.5,3.6-1.6l3.7,3.7L13.7,12.5z"
            />
          </g>
        );
      case "screen-full":
        return (
          <g>
            <path d="M2.8 15.8L0 13v7h7l-2.8-2.8 4.34-4.32-1.42-1.42L2.8 15.8zM17.2 4.2L20 7V0h-7l2.8 2.8-4.34 4.32 1.42 1.42L17.2 4.2zm-1.4 13L13 20h7v-7l-2.8 2.8-4.32-4.34-1.42 1.42 4.33 4.33zM4.2 2.8L7 0H0v7l2.8-2.8 4.32 4.34 1.42-1.42L4.2 2.8z" />
          </g>
        );
      case "link":
        return (
          <g>
            <path d="M9.26 13a2 2 0 0 1 .01-2.01A3 3 0 0 0 9 5H5a3 3 0 0 0 0 6h.08a6.06 6.06 0 0 0 0 2H5A5 5 0 0 1 5 3h4a5 5 0 0 1 .26 10zm1.48-6a2 2 0 0 1-.01 2.01A3 3 0 0 0 11 15h4a3 3 0 0 0 0-6h-.08a6.06 6.06 0 0 0 0-2H15a5 5 0 0 1 0 10h-4a5 5 0 0 1-.26-10z" />
          </g>
        );
      case "dashboard":
        return (
          <g>
            <path
              d="M2.9,5.2c2-2,4.3-2.9,7.1-2.9c2.8,0,5.1,1,7.1,2.9c2,2,2.9,4.3,2.9,7.1c0,1.8-0.5,3.5-1.4,5c-0.2,0.3-0.5,0.5-0.9,0.5H2.3
        c-0.4,0-0.7-0.2-0.9-0.5C0.5,15.7,0,14,0,12.2C0,9.5,1,7.1,2.9,5.2z M2.6,14.1c0.2,0.2,0.5,0.3,0.8,0.3c0.3,0,0.6-0.1,0.8-0.3
        c0.2-0.2,0.3-0.5,0.3-0.8c0-0.3-0.1-0.6-0.3-0.8c-0.2-0.2-0.5-0.3-0.8-0.3c-0.3,0-0.6,0.1-0.8,0.3c-0.2,0.2-0.3,0.5-0.3,0.8
        C2.2,13.6,2.3,13.9,2.6,14.1z M4.2,8.6C4.4,8.8,4.7,8.9,5,8.9c0.3,0,0.6-0.1,0.8-0.3C6,8.3,6.1,8.1,6.1,7.8C6.1,7.5,6,7.2,5.8,7
        C5.6,6.8,5.3,6.7,5,6.7C4.7,6.7,4.4,6.8,4.2,7C4,7.2,3.9,7.5,3.9,7.8C3.9,8.1,4,8.3,4.2,8.6z M13.6,6.4c0-0.1,0-0.2,0-0.3
        c0-0.1,0-0.2-0.1-0.3c0-0.1-0.1-0.2-0.2-0.2c-0.1-0.1-0.2-0.1-0.3-0.2c-0.2-0.1-0.5-0.1-0.7,0.1C12.2,5.5,12,5.6,12,5.8l-2.1,6.4
        c-0.6,0-1.1,0.3-1.5,0.7c-0.4,0.4-0.6,0.9-0.6,1.5c0,0.4,0.1,0.8,0.3,1.1h3.8c0.2-0.3,0.3-0.7,0.3-1.1c0-0.7-0.3-1.2-0.8-1.7
        L13.6,6.4z M10,4.4c-0.2,0-0.4,0.1-0.6,0.2C9.3,4.7,9.1,4.8,9,5C8.9,5.2,8.9,5.3,8.9,5.6c0,0.3,0.1,0.6,0.3,0.8
        C9.4,6.6,9.7,6.7,10,6.7c0.2,0,0.4-0.1,0.6-0.2l0.3-1c0,0,0-0.1,0.1-0.1l0-0.1C11,5,10.8,4.8,10.7,4.7C10.5,4.5,10.3,4.4,10,4.4z
         M14.1,8.4c0.2,0.3,0.5,0.5,0.9,0.5c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8c0-0.3-0.1-0.6-0.3-0.8
        c-0.2-0.2-0.5-0.3-0.8-0.3c-0.1,0-0.2,0-0.4,0.1L14.1,8.4z M15.9,14.1c0.2,0.2,0.5,0.3,0.8,0.3c0.3,0,0.6-0.1,0.8-0.3
        c0.2-0.2,0.3-0.5,0.3-0.8c0-0.3-0.1-0.6-0.3-0.8c-0.2-0.2-0.5-0.3-0.8-0.3c-0.3,0-0.6,0.1-0.8,0.3c-0.2,0.2-0.3,0.5-0.3,0.8
        C15.6,13.6,15.7,13.9,15.9,14.1z"
            />
          </g>
        );
      case "dropdown":
        return (
          <g>
            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
          </g>
        );
      case "quiz":
        return (
          <g>
            <path d="M2 4v14h14v-6l2-2v10H0V2h10L8 4H2zm10.3-.3l4 4L8 16H4v-4l8.3-8.3zm1.4-1.4L16 0l4 4-2.3 2.3-4-4z" />
          </g>
        );
      case "advert":
        return (
          <path
            d="M19.4,2.5c0.2,0,0.3,0.1,0.4,0.2S20,2.9,20,3.1v1.2c0,0.2-0.1,0.3-0.2,0.4S19.6,5,19.4,5H5v14.4c0,0.2-0.1,0.3-0.2,0.4
        S4.6,20,4.4,20H3.1c-0.2,0-0.3-0.1-0.4-0.2s-0.2-0.3-0.2-0.4V5H0.6C0.4,5,0.3,4.9,0.2,4.8S0,4.6,0,4.4V3.1c0-0.2,0.1-0.3,0.2-0.4
        s0.3-0.2,0.4-0.2h1.9V0.6c0-0.2,0.1-0.3,0.2-0.4S2.9,0,3.1,0h1.2c0.2,0,0.3,0.1,0.4,0.2S5,0.4,5,0.6v1.9H19.4z M6.2,15V6.2h12.5V15
        H6.2z"
          />
        );
      case "download":
        return (
          <g>
            <path d="M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z" />
          </g>
        );
      case "badge":
        return (
          <g>
            <path
              d="M10,12 C13.3137085,12 16,9.3137085 16,6 C16,2.6862915 13.3137085,0 10,0 C6.6862915,0 4,2.6862915 4,6 C4,9.3137085 6.6862915,12 10,12 Z M10,9 C11.6568542,9 13,7.65685425 13,6 C13,4.34314575 11.6568542,3 10,3 C8.34314575,3 7,4.34314575 7,6 C7,7.65685425 8.34314575,9 10,9 Z M14,11.7453107 L14,20 L10,16 L6,20 L6,11.7453107 C7.13383348,12.5361852 8.51275186,13 10,13 C11.4872481,13 12.8661665,12.5361852 14,11.7453107 L14,11.7453107 Z"
              id="Combined-Shape"
            />
          </g>
        );
      case "star":
        return (
          <g>
            <polygon points="10 15 4.12214748 18.0901699 5.24471742 11.545085 0.489434837 6.90983006 7.06107374 5.95491503 10 0 12.9389263 5.95491503 19.5105652 6.90983006 14.7552826 11.545085 15.8778525 18.0901699" />
          </g>
        );
      case "youtube":
        return (
          <g>
            <path
              stroke="null"
              fillRule="evenodd"
              clipRule="evenodd"
              d="m13.167761,12.440576c-0.092436,0 -0.158937,0.025935 -0.199502,0.081131c-0.040233,0.051871 -0.059851,0.140982 -0.059851,0.264673l0,0.297923l0.513053,0l0,-0.297923c0,-0.123691 -0.020615,-0.212802 -0.061513,-0.264673c-0.03857,-0.055196 -0.104074,-0.081131 -0.192187,-0.081131zm-2.001006,-0.010308c0.077806,0 0.138654,0.02527 0.180882,0.076476c0.040898,0.051206 0.061513,0.127349 0.061513,0.226767l0,1.524196c0,0.095096 -0.017623,0.161929 -0.050873,0.20316c-0.03325,0.042228 -0.085121,0.062843 -0.156277,0.062843c-0.049211,0 -0.095429,-0.010973 -0.139984,-0.03192c-0.044888,-0.020615 -0.091106,-0.056858 -0.137989,-0.104074l0,-1.839077c0.039568,-0.040565 0.079468,-0.070823 0.119701,-0.090108c0.040233,-0.019618 0.081131,-0.028263 0.123026,-0.028263zm1.741986,1.113554l0,0.555946c0,0.155612 0.018953,0.263343 0.056526,0.323858c0.039235,0.060183 0.104074,0.089443 0.196842,0.089443c0.096094,0 0.163259,-0.02527 0.201497,-0.076143c0.037905,-0.050873 0.058188,-0.162594 0.058188,-0.336826l0,-0.134664l0.596844,0l0,0.151622c0,0.302911 -0.072153,0.530676 -0.218455,0.684625c-0.144639,0.152619 -0.362096,0.22843 -0.651042,0.22843c-0.259685,0 -0.46484,-0.080466 -0.614134,-0.24306c-0.148962,-0.161597 -0.224772,-0.384707 -0.224772,-0.669662l0,-1.325359c0,-0.255363 0.082793,-0.46484 0.246718,-0.625772c0.163924,-0.161264 0.375064,-0.24173 0.635414,-0.24173c0.26567,0 0.469828,0.074813 0.612804,0.224107c0.142644,0.148962 0.213467,0.363426 0.213467,0.643394l0,0.752788l-1.109897,0l0,-0.000998zm-1.039074,1.275816c-0.090108,0.111721 -0.222445,0.166584 -0.394682,0.166584c-0.114049,0 -0.214797,-0.020615 -0.303243,-0.063841c-0.088778,-0.042893 -0.172569,-0.108729 -0.248048,-0.199835l0,0.226435l-0.586536,0l0,-4.000683l0.586536,0l0,1.288451c0.078803,-0.089776 0.161264,-0.158937 0.248713,-0.205155c0.088778,-0.047216 0.177557,-0.070158 0.267665,-0.070158c0.184207,0 0.324191,0.062843 0.420617,0.187865c0.097756,0.126019 0.145637,0.310226 0.145637,0.551956l0,1.637912c0,0.208812 -0.045553,0.368746 -0.136659,0.480468zm-2.54864,0.129344l0,-0.324523c-0.108064,0.120034 -0.218787,0.211472 -0.335496,0.273318c-0.116044,0.063508 -0.228097,0.093766 -0.337159,0.093766c-0.134664,0 -0.234415,-0.042893 -0.303576,-0.131671c-0.066833,-0.088446 -0.101414,-0.218787 -0.101414,-0.395347l0,-2.467841l0.579886,0l0,2.264017c0,0.070158 0.012303,0.120366 0.035578,0.151954c0.025603,0.031588 0.065171,0.046883 0.119036,0.046883c0.04256,0 0.097091,-0.020615 0.162262,-0.062511c0.065503,-0.041563 0.124689,-0.094099 0.180217,-0.157939l0,-2.242404l0.579886,0l0,2.951967l-0.579221,0l0,0.000333zm-2.008986,-3.419467l0,3.419467l-0.654367,0l0,-3.419467l-0.676312,0l0,-0.581216l2.006991,0l0,0.581216l-0.676312,0zm2.685964,-1.869335c0,-0.000333 4.016643,0.005985 4.493453,0.48213c0.478473,0.477143 0.483793,2.830935 0.483793,2.844568c0,0 -0.00399,2.366428 -0.483793,2.8449c-0.47681,0.47548 -4.493453,0.485788 -4.493453,0.485788s-4.01631,-0.010308 -4.494118,-0.48612c-0.47814,-0.477143 -0.479138,-2.826945 -0.479138,-2.8449c0,-0.013633 0.00133,-2.367425 0.479138,-2.844568c0.47814,-0.475813 4.494118,-0.48213 4.494118,-0.481798zm3.167429,-1.237911l-0.653702,0l0,-0.359104c-0.119036,0.132004 -0.244723,0.23375 -0.375729,0.302246c-0.130341,0.069161 -0.25636,0.103741 -0.379054,0.103741c-0.152287,0 -0.265005,-0.048546 -0.341481,-0.145304c-0.076143,-0.096759 -0.114714,-0.24173 -0.114714,-0.435912l0,-2.717219l0.652372,0l0,2.492779c0,0.076808 0.014963,0.132669 0.042228,0.166917c0.0266,0.03458 0.071821,0.051871 0.132669,0.051871c0.047548,0 0.108729,-0.022943 0.182212,-0.068496c0.073151,-0.045553 0.140649,-0.103741 0.201165,-0.175229l0,-2.467841l0.653702,0l0,3.251552l0.000333,0zm-3.54881,-0.554283c0.046218,0.048878 0.112719,0.072818 0.199502,0.072818c0.088446,0 0.158272,-0.024938 0.210807,-0.074148c0.052203,-0.050541 0.078138,-0.119036 0.078138,-0.205487l0,-1.771246c0,-0.071156 -0.0266,-0.128679 -0.080133,-0.172569c-0.053201,-0.043558 -0.123026,-0.065171 -0.208812,-0.065171c-0.080133,0 -0.144639,0.021613 -0.194847,0.065171c-0.049211,0.04389 -0.074813,0.101414 -0.074813,0.172569l0,1.771246c0,0.088778 0.02394,0.157274 0.070158,0.206817zm-0.478473,-2.55529c0.175562,-0.149294 0.412637,-0.224107 0.708898,-0.224107c0.269993,0 0.492105,0.078803 0.66534,0.23641c0.171904,0.157274 0.258355,0.360101 0.258355,0.607816l0,1.679475c0,0.277973 -0.084788,0.495763 -0.253368,0.654367c-0.170574,0.158272 -0.402994,0.237408 -0.700252,0.237408c-0.285288,0 -0.514383,-0.081796 -0.686287,-0.244723c-0.170574,-0.163592 -0.256693,-0.383377 -0.256693,-0.659687l0,-1.685128c-0.000333,-0.25237 0.087448,-0.45287 0.264008,-0.601831zm-2.043567,-1.297761l-0.74115,0l0.875814,2.661026l0,1.746309l0.73583,0l0,-1.82877l0.855864,-2.578565l-0.748133,0l-0.4542,1.761604l-0.046218,0l-0.477808,-1.761604zm2.905416,15.96017c-5.508919,0 -9.975107,-4.466188 -9.975107,-9.975107c0,-5.509251 4.466188,-9.975107 9.975107,-9.975107s9.975107,4.465855 9.975107,9.975107c0,5.508919 -4.466188,9.975107 -9.975107,9.975107z"
            />
          </g>
        );
      case "summer":
        return (
          <path
            d="M4.5,11.5c0.3,0.3,0.7,0.6,1.1,0.8c-0.3,0.3-0.6,0.7-0.8,1.1l-2.4,0.8c-0.2,0.1-0.3,0-0.5-0.1c-0.1-0.1-0.2-0.3-0.1-0.5
        l0.9-2.8L0.2,9.4C0.1,9.3,0,9.2,0,9s0.1-0.3,0.2-0.4l2.6-1.3L1.9,4.5C1.9,4.3,1.9,4.2,2,4c0.1-0.1,0.3-0.2,0.5-0.1l2.8,0.9l1.3-2.6
        C6.7,2.1,6.8,2,7,2s0.3,0.1,0.4,0.3l1.3,2.6l2.8-0.9c0.2-0.1,0.3,0,0.5,0.1c0.1,0.1,0.2,0.3,0.1,0.5l-0.9,2.8
        c-0.4,0-0.7,0.1-0.9,0.2c-0.2-0.4-0.4-0.8-0.7-1C8.8,5.8,8,5.5,7,5.5s-1.8,0.3-2.5,1S3.5,8,3.5,9S3.8,10.8,4.5,11.5z M4.4,9
        c0-0.7,0.3-1.3,0.8-1.9S6.3,6.4,7,6.4c0.5,0,1,0.1,1.4,0.4c0.4,0.3,0.7,0.7,1,1.1c-1.2,0.8-1.9,1.8-2.1,3.3
        c-0.2,0.1-0.5,0.2-0.8,0.4c-0.6-0.1-1.1-0.4-1.5-0.9C4.6,10.2,4.4,9.6,4.4,9z M18,12.2c0.6,0.2,1.1,0.6,1.5,1.1
        c0.4,0.5,0.6,1.1,0.6,1.7c0,0.8-0.3,1.5-0.9,2.1C18.5,17.7,17.8,18,17,18H8.5c-0.8,0-1.5-0.3-2.1-0.9c-0.6-0.6-0.9-1.3-0.9-2.1
        c0-0.8,0.3-1.5,0.8-2s1.2-0.9,2-0.9c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1s0-0.1,0-0.1c0-1,0.3-1.8,1-2.5s1.5-1,2.5-1
        c0.7,0,1.3,0.2,1.9,0.6s1,0.9,1.3,1.5c0.3-0.2,0.7-0.3,1.1-0.3c0.5,0,1,0.2,1.4,0.6C17.8,11,18,11.5,18,12C18,12,18,12.1,18,12.2
        C18,12.1,18,12.2,18,12.2z"
          />
        );
      case "fb":
        return (
          <g>
            <path d="m8.590179,15.432883l2.24506,0l0,-5.43355l1.497705,0l0.198407,-1.872215l-1.696112,0l0.00233,-0.937439c0,-0.488027 0.046606,-0.750018 0.747022,-0.750018l0.936107,0l0,-1.872547l-1.498038,0c-1.79931,0 -2.432481,0.908477 -2.432481,2.43581l0,1.124194l-1.121531,0l0,1.872547l1.121531,0l0,5.433217zm1.40982,4.554036c-5.515443,0 -9.98692,-4.471477 -9.98692,-9.98692c0,-5.515776 4.471477,-9.98692 9.98692,-9.98692s9.98692,4.471144 9.98692,9.98692c0,5.515443 -4.471477,9.98692 -9.98692,9.98692z" />
          </g>
        );
      case "instagram":
        return (
          <g>
            <path d="m13.082603,7.532188l0,-0.001995c0.166915,0 0.334162,0.003325 0.501409,-0.000665c0.214795,-0.00532 0.389689,-0.189525 0.389689,-0.404652c0,-0.320197 0,-0.640727 0,-0.960924c0,-0.229757 -0.181877,-0.412299 -0.410969,-0.412632c-0.319532,0 -0.639064,-0.000332 -0.958596,0c-0.22876,0.000332 -0.410969,0.18354 -0.410969,0.413297c-0.000332,0.317537 -0.00133,0.635074 0.000997,0.952611c0.000332,0.047547 0.00931,0.096757 0.024272,0.141645c0.057522,0.16891 0.212467,0.27265 0.401992,0.273647c0.153947,0 0.308227,-0.000332 0.462174,-0.000332zm-3.082603,0.411967c-1.125179,-0.000665 -2.039885,0.904731 -2.055512,2.02459c-0.016292,1.150448 0.904399,2.06183 2.008297,2.085437c1.148453,0.024605 2.077457,-0.893094 2.10173,-2.009295c0.024937,-1.150448 -0.903401,-2.101397 -2.054515,-2.100732zm-3.9747,1.096916l0,0.027265c0,1.501236 -0.000332,3.002471 0,4.503707c0,0.215792 0.186865,0.401659 0.402989,0.401659c2.380697,0.000332 4.761061,0.000332 7.141758,0c0.21812,0 0.403987,-0.185202 0.403987,-0.402989c0.000332,-1.499241 0,-2.999146 0,-4.498054l0,-0.031255l-0.968239,0c0.136657,0.436904 0.178552,0.881456 0.12502,1.334653c-0.053532,0.453197 -0.199832,0.874806 -0.437569,1.264496s-0.546629,0.713212 -0.924016,0.970234c-0.978879,0.666994 -2.267979,0.725514 -3.307041,0.14231c-0.525017,-0.294262 -0.937316,-0.704899 -1.225261,-1.234571c-0.428592,-0.789021 -0.497087,-1.61761 -0.245717,-2.477454c-0.32186,0 -0.641724,0 -0.965911,0zm8.032857,6.03121c0.052867,-0.008645 0.105735,-0.016292 0.157937,-0.027597c0.414294,-0.088112 0.752779,-0.433579 0.833909,-0.850201c0.008312,-0.045552 0.014962,-0.090772 0.022277,-0.135992l0,-8.116979c-0.006982,-0.044222 -0.0133,-0.08911 -0.021612,-0.133332c-0.08911,-0.454527 -0.464169,-0.807309 -0.924349,-0.870484c-0.019285,-0.002327 -0.037572,-0.00665 -0.056525,-0.009975l-8.139257,0c-0.048877,0.008977 -0.09842,0.015627 -0.146632,0.0266c-0.449539,0.10241 -0.782039,0.464169 -0.846211,0.919694c-0.00266,0.018952 -0.00665,0.037905 -0.009642,0.056857l0,8.138924c0.00931,0.051205 0.016625,0.103407 0.028262,0.154612c0.099417,0.439564 0.474477,0.780376 0.921024,0.837899c0.02128,0.00266 0.043225,0.006982 0.064837,0.009975l8.115982,0zm-4.058157,4.902706c-5.508853,0 -9.974987,-4.466134 -9.974987,-9.974987c0,-5.509185 4.466134,-9.974987 9.974987,-9.974987s9.974987,4.465802 9.974987,9.974987c0,5.508853 -4.466134,9.974987 -9.974987,9.974987z" />
          </g>
        );
      case "twitter":
        return (
          <g>
            <path d="m11.38555,6.104033c-0.870832,0.316878 -1.421129,1.134176 -1.358617,2.028616l0.020948,0.345141l-0.348466,-0.042228c-1.267843,-0.16193 -2.375752,-0.711229 -3.31641,-1.634265l-0.459855,-0.45786l-0.118372,0.338158c-0.250709,0.75379 -0.090441,1.549808 0.431925,2.085142c0.27864,0.29593 0.215796,0.338158 -0.264674,0.16193c-0.16725,-0.056193 -0.313553,-0.098422 -0.327518,-0.077474c-0.048546,0.049543 0.118372,0.690281 0.250709,0.943983c0.181215,0.352456 0.550297,0.697264 0.954623,0.901755l0.341483,0.16193l-0.403994,0.006983c-0.390029,0 -0.403994,0.006983 -0.362098,0.15528c0.13932,0.45786 0.689616,0.943983 1.302757,1.155457l0.431925,0.147632l-0.376064,0.225439c-0.557279,0.324525 -1.212315,0.507403 -1.867351,0.521036c-0.313885,0.006983 -0.571577,0.035246 -0.571577,0.056526c0,0.070159 0.850217,0.46451 1.344652,0.61979c1.483972,0.45786 3.246916,0.260352 4.570621,-0.521369c0.940658,-0.556614 1.880984,-1.662527 2.320223,-2.733528c0.237076,-0.570247 0.47382,-1.612984 0.47382,-2.11274c0,-0.324193 0.020948,-0.366421 0.410977,-0.75379c0.230094,-0.225439 0.44589,-0.471825 0.487786,-0.542316c0.069826,-0.134 0.062511,-0.134 -0.292605,-0.014298c-0.592192,0.211473 -0.675984,0.183211 -0.383046,-0.133667c0.215796,-0.225439 0.47382,-0.634088 0.47382,-0.75379c0,-0.020948 -0.104407,0.013965 -0.223111,0.077474c-0.125355,0.070491 -0.403994,0.176228 -0.61314,0.239404l-0.376064,0.120034l-0.341483,-0.232754c-0.188198,-0.126685 -0.45254,-0.267667 -0.592192,-0.309895c-0.355448,-0.098422 -0.899095,-0.084456 -1.21963,0.028263zm-1.38555,13.871132c-5.508951,0 -9.975165,-4.466214 -9.975165,-9.975165c0,-5.509284 4.466214,-9.975165 9.975165,-9.975165s9.975165,4.465881 9.975165,9.975165c0,5.508951 -4.466214,9.975165 -9.975165,9.975165z" />
          </g>
        );
      default:
        return (
          <g>
            <path d="M0 4c0-1.1.9-2 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm11 9l-3-3-6 6h16l-5-5-2 2zm4-4a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
          </g>
        );
    }
  }

  render() {
    let styles = {
      fill: "currentcolor",
      verticalAlign: "middle",
      width: this.props.size ? this.props.size : 20, // CSS instead of the width attr to support non-pixel units
      height: this.props.size // Prevents scaling issue in IE
    };
    return (
      <svg
        className={this.props.className}
        width={this.props.size ? this.props.size : 20}
        height={this.props.size ? this.props.size : 20}
        viewBox="0 0 20 20"
        preserveAspectRatio="xMidYMid meet"
        fit="true"
        style={this._mergeStyles(
          styles,
          this.props.style // This lets the parent pass custom styles
        )}>
        {this.renderGraphic()}
      </svg>
    );
  }
}

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object
};

export default Icon;
